// extracted by mini-css-extract-plugin
export var container = "_4b-0";
export var fallback = "_4b-5";
export var fallbackIcon = "_4b-6";
export var hidden = "_4b-2";
export var image = "_4b-3";
export var loaded = "_4b-4";
export var placeholder = "_4b-1";